export enum TrPlayerAction {
    Navigate = 'player:navigateTo',
    FireAction = 'player:execute',
    ReplayVideo = 'player:replayVideo',
}
